import { ItemsListRowItemBase } from '../../components/items-list/list-row/list-row-item/list-row-item-base';
import { Injector } from '@angular/core';
import { CustomerService } from '@fi-app/customer-billing/customer-billing-customer/customer.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { InvoiceService } from '@fi-app/customer-billing/customer-billing-invoice/invoice.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { AccessRightType, ApplicationSettingsType } from '@fi-shared/types';

export class InvoicesListItemBase extends ItemsListRowItemBase {
    protected customerService: CustomerService;
    protected fiLoadingService: LoadingService;
    protected fiDialogsService: FiDialogsService;
    protected invoiceService: InvoiceService;
    protected fiStateService: FiStateService;
    protected customerDataService: FiCustomerDataService;

    protected customerBillingShareAccess: boolean;
    protected customerBillingWriteAccess: boolean;

    constructor(injector: Injector) {
        super(injector);

        this.customerService = injector.get(CustomerService);
        this.fiLoadingService = injector.get(LoadingService);
        this.fiDialogsService = injector.get(FiDialogsService);
        this.invoiceService = injector.get(InvoiceService);
        this.fiStateService = injector.get(FiStateService);
        this.customerDataService = injector.get(FiCustomerDataService);

        const accessToApplicationTypeService = injector.get(AccessToApplicationTypeService);

        this.customerBillingWriteAccess = accessToApplicationTypeService.HasAccessToApplicationType(
            ApplicationSettingsType.CustomerBilling,
            AccessRightType.Write,
        );
        this.customerBillingShareAccess = accessToApplicationTypeService.HasAccessToApplicationType(
            ApplicationSettingsType.CustomerBilling,
            AccessRightType.Share,
        );
    }
}
